import { transactionTypesConstants } from '../constants/transaction_types';

export function transactionTypes(state = {}, action) {
    switch (action.type) {
        case transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_REQUEST:
            return {
                ...state,
                loading: true,
                dates: []
            };
        case transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_SUCCESS:
            return {

                ...state,
                loading: false,
                items: action.transactionTypes,
                dates: action.dates
            };
        case transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_FAILURE:
            return {
                ...state,
                loading: false,
                dates: [],
                error: action.error
            };  
            
        case transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_REQUEST:
            return {
                ...state,
                statusLoading: true,
            };
        case transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_SUCCESS:
            return {

                ...state,
                statusLoading: false,
            };
        case transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_FAILURE:
            return {
                ...state,
                statusLoading: false,
            };            
            
        case transactionTypesConstants.GET_TRANSACTION_TYPES_REQUEST:
            return {
                ...state,
                transactionTypesLoading: true,
            };
        case transactionTypesConstants.GET_TRANSACTION_TYPES_SUCCESS:
            return {

                ...state,
                transactionTypesLoading: false,
                transactionTypes: action.transactionTypes,
            };
        case transactionTypesConstants.GET_TRANSACTION_TYPES_FAILURE:
            return {
                ...state,
                transactionTypesLoading: false,
                error: action.error
            };  
            
        default:
            return state
    }
}
